import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import type { ListVariantsType } from "./List";
import * as TooltipStyles from "../../../../../../common-deprecated/styles/v2/toyota/components/Tooltip";
import { type UscColorType, UscColorProps } from "../../../../../shared-components/toyota/styles/Variables.types";

// STYLES
const commonStyles = css`
    &[hidden] {
        display: none;
    }

    ${TooltipStyles.TooltipButton} {
        color: var(--color-primary-black);
    }
`;

const basket = css`
    ${commonStyles};
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        padding-inline: 0;
        padding-block: 0 calc(var(--spacing-3) / 2);
        border-bottom: 1px solid var(--color-grey-4);

        @supports not (padding-block: 0) {
            padding-bottom: calc(var(--spacing-3) / 2) !important;
        }
    }
`;

const basketSubList = css`
    ${commonStyles};
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    margin: 0;
    padding: var(--spacing-2) calc(var(--spacing-3) / 2);
    list-style: none;
    background-color: var(--color-grey-1);

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        padding: 0;
        border: 0;

        /* Text element in list */
        & > span {
            display: inline-flex;
            align-items: center;
            column-gap: calc(var(--spacing-1) / 2);
        }
    }

    @supports not (padding-inline: 0) {
        li {
            &:not(:nth-last-child(1)) {
                margin-bottom: calc(var(--spacing-3) / 2) !important;
            }
            & > span:not(:nth-last-child(1)) {
                margin-bottom: calc(var(--spacing-1) / 2) !important;
            }
        }
    }
`;

const basketPanelList = css`
    ${commonStyles};
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0;

        @supports not (padding-inline: 0) {
            &:not(:nth-last-child(1)) {
                margin-bottom: calc(var(--spacing-3) / 2) !important;
            }
        }
    }
`;

const specs = css`
    ${commonStyles};
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0;

        @supports not (padding-inline: 0) {
            &:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-1) !important;
            }
        }
    }
`;

const usp = css<{ columns?: number }>`
    ${commonStyles};
    display: flex;
    flex-wrap: wrap;
    row-gap: var(--spacing-1);
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: inline-flex;
        align-items: flex-start;
        width: 100%;
        font-family: var(--font-book);
        font-size: 1.3rem;
        line-height: 2rem;

        @media screen and (min-width: ${breakpoints.md}) {
            width: auto;
        }

        ${({ columns }) =>
            columns &&
            css`
                @media screen and (min-width: ${breakpoints.md}) {
                    flex: 1 0 calc(100% / ${columns});
                }
            `};

        @supports not (padding-inline: 0) {
            &:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-1) !important;
            }
        }
    }

    li::before {
        display: block;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        margin-inline-end: var(--spacing-1);
        content: "";
        background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciAxMjcgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNzc3OSAwLjcxMjMxNEMxMS45MzY2IDAuODY2MDI0IDExLjk0MDYgMS4xMTkyNiAxMS43ODY5IDEuMjc3OTNMNC4zOTAzNyA4LjkxMzA2QzQuMDQwNjMgOS4yNzQwOCAzLjQ2Mjk4IDkuMjc4NjcgMy4xMDc1NiA4LjkyMzI0TDAuMjE2NzY3IDYuMDMyNDVDMC4wNjA1NTY5IDUuODc2MjQgMC4wNjA1NTY5IDUuNjIyOTggMC4yMTY3NjcgNS40NjY3N0MwLjM3Mjk3NiA1LjMxMDU2IDAuNjI2MjQyIDUuMzEwNTYgMC43ODI0NTIgNS40NjY3N0wzLjY3MzI0IDguMzU3NTZDMy43MTI3MyA4LjM5NzA1IDMuNzc2OTIgOC4zOTY1NCAzLjgxNTc4IDguMzU2NDNMMTEuMjEyMyAwLjcyMTI5MkMxMS4zNjYgMC41NjI2MjIgMTEuNjE5MyAwLjU1ODYwMyAxMS43Nzc5IDAuNzEyMzE0WiIgZmlsbD0iI0Q0MDYwNSIvPgo8L3N2Zz4K");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 14px 20px;

        @supports not (margin-inline: 0) {
            margin-right: var(--spacing-1);
        }
    }

    li::after {
        display: table;
        clear: both;
        content: "";
    }
`;

const bullet = css<{ columns?: number }>`
    ${commonStyles};
    margin: 0;
    list-style: none;
    padding-inline-start: calc(var(--spacing-5) / 2);

    ${(props) =>
        props.columns &&
        css`
            @media screen and (min-width: ${breakpoints.lg}) {
                columns: ${props.columns};
                column-gap: var(--spacing-4);
            }
        `};

    li {
        position: relative;
        font-family: var(--font-book);
        font-size: 1.6rem;
        line-height: 2.4rem;

        &:not(:last-child) {
            margin-bottom: 8px !important;
        }

        /* Custom marker */
        &::before {
            display: block;
            position: absolute;
            top: 12px;
            left: -18px;
            width: 4px;
            height: 4px;
            content: "";
            background-color: var(--color-primary-red);
            border-radius: 50%;
        }
    }

    @supports not (padding-inline: 0) {
        padding-left: calc(var(--spacing-5) / 2);

        li::before {
            left: -16px;
        }
    }
`;

const customIcon = css<{ columns?: number }>`
    ${commonStyles};
    display: flex;
    flex-wrap: wrap;
    row-gap: var(--spacing-1);
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: inline-flex;
        align-items: flex-start;
        gap: var(--spacing-1);
        width: 100%;
        font-family: var(--font-book);
        font-size: 1.3rem;
        line-height: 2rem;

        @media screen and (min-width: ${breakpoints.md}) {
            width: auto;
        }

        ${({ columns }) =>
            columns &&
            css`
                @media screen and (min-width: ${breakpoints.md}) {
                    flex: 1 0 calc(100% / ${columns});
                }
            `};

        @supports not (padding-inline: 0) {
            /* List marker */
            & > span {
                margin-right: var(--spacing-1);

                [dir="rtl"] & {
                    margin-left: var(--spacing-1);
                    margin-right: unset;
                }
            }

            /* List info icon */
            & > div {
                margin-left: var(--spacing-1);

                [dir="rtl"] & {
                    margin-left: unset;
                    margin-right: var(--spacing-1);
                }
            }

            &:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-1) !important;
            }
        }
    }
`;

const unstyled = css<{ columns?: number }>`
    ${commonStyles};
    padding-inline-start: 0;
    list-style: none;

    ${(props) =>
        props.columns &&
        css`
            @media screen and (min-width: ${breakpoints.lg}) {
                columns: ${props.columns};
                column-gap: var(--spacing-4);
            }
        `};

    li {
        break-inside: avoid;
        &:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-1);
        }
    }

    @supports not (padding-inline: 0) {
        padding-left: 0;
    }
`;

// COMPONENT
export const IconWrapper = styled.span<{ color?: UscColorType }>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ color }) => color && `var(${UscColorProps[color]})`};
`;

export const ListVariants = {
    basket,
    "basket-sub-list": basketSubList,
    "basket-panel-list": basketPanelList,
    "custom-icon": customIcon,
    specs,
    usp,
    bullet,
    unstyled,
};

const ListVariant = styled.ol<{ variant: ListVariantsType; columns?: number; skeleton?: boolean }>`
    ${({ variant }) =>
        variant &&
        css`
            ${ListVariants[variant]};
        `};
`;

export default ListVariant;
